import React, { FunctionComponent, useRef } from "react";

import {
    ReportDataWrapper,
    ReportDataWrapperHead,
    ReportP,
    getPrettyNumber,
    ChartBodyWrapper,
    ReportH4,
    BuxTooltip,
    ReportHeaderInnerContainer,
} from "../../../Common";
import {
    DigitalShareItemType,
    DigitalShareAppType,
} from "../../../../Enums/Enums";
import { RenderType } from "../../../../Enums/RenderType";
import { VolumeMetricsTableHeader, VolumeMetricsTableRow, VolumeMetricsCell } from "../Styled/Table";
import { IGPSData } from "../../../../Models/Models";
import { isOutputSelected, registerElement, registerRef } from "../../../Common/DigitalShare/DigitalShareGenerator";
import { featureFlags } from "../../../../Common/CurrentFeatureFlags";
import { GPSVolumeMetricsOutput } from "./GPSVolumeMetricsOutput";

const getVolumeMetricsTableRows = (
    rowText: string,
    visitorCount: number,
    visitCount: number,
): JSX.Element => {
    return (
        <VolumeMetricsTableRow>
            <VolumeMetricsCell>{rowText}</VolumeMetricsCell>
            <VolumeMetricsCell>
                <div>{getPrettyNumber(visitorCount, 0)}</div>
            </VolumeMetricsCell>
            <VolumeMetricsCell>
                <div>{getPrettyNumber(visitCount, 0)}</div>
            </VolumeMetricsCell>
            <VolumeMetricsCell>
                <div>{getPrettyNumber(visitCount / visitorCount, 2)}</div>
            </VolumeMetricsCell>
        </VolumeMetricsTableRow>
    );
};

interface IGPSVolumeMetrics {
  scrollableParentSelector: string;
  chartAnim: string;
  storeData: IGPSData;
  benchmarkData?: IGPSData;
  itemType?: DigitalShareItemType;
  renderType?: RenderType;
  app?: DigitalShareAppType;
}

export const GPSVolumeMetrics: FunctionComponent<IGPSVolumeMetrics> = (
    props: IGPSVolumeMetrics,
) => {
    const {
        scrollableParentSelector,
        chartAnim,
        storeData,
        benchmarkData,
        renderType,
        itemType,
        app,
    } = props;

    const volumeMetricsRef = useRef<HTMLDivElement>(null);

    //---------THIS PART FOR PRINT AND SHARE FEATURE--------
    if (
        featureFlags.DigitalShare
        && renderType === RenderType.DIGITAL_SHARE
        && isOutputSelected(app, itemType)
    ) {
        registerRef(app, itemType, volumeMetricsRef);
        const volumeMetricsElement = (
            <GPSVolumeMetricsOutput
                storeData={storeData}
                benchmarkData={benchmarkData}
            />
        );
        registerElement(
            app.toString(),
            itemType.toString(),
            " Observed mobile device activity during the selected period",
            volumeMetricsElement,
        );
    }

    return (
        <ReportDataWrapper>
            <ReportDataWrapperHead>
                <ReportHeaderInnerContainer>
                    <ReportH4
                        style={{ margin: "0", fontSize: "14px", height: "17px" }}
                    >Volume Metrics</ReportH4>
                    <BuxTooltip
                        placement="left"
                        content="Provides the observed number of visitors, visits, and average visits per visitor observed in the study area during the selected date range, based on Buxton’s mobile device data."
                        trigger="click"
                        allowClickThrough={false}
                        iconSize={14}
                    />
                </ReportHeaderInnerContainer>
            </ReportDataWrapperHead>
            <ReportP>
                Observed mobile device activity during the selected period.
            </ReportP>
            <ChartBodyWrapper
                scrollableParentSelector={scrollableParentSelector}
                animateIn={chartAnim}
                offset={100}
                animateOnce={true}
            >
                <VolumeMetricsTableHeader>
                    <VolumeMetricsCell></VolumeMetricsCell>
                    <VolumeMetricsCell>Number of visitors</VolumeMetricsCell>
                    <VolumeMetricsCell>Number of visits</VolumeMetricsCell>
                    <VolumeMetricsCell>Visits per visitor</VolumeMetricsCell>
                </VolumeMetricsTableHeader>
                {getVolumeMetricsTableRows(
                    "Your Selection",
                    storeData.mapData.length,
                    storeData.visitsCount,
                )}
                {/* Benchmark Data */}
                {benchmarkData && getVolumeMetricsTableRows(
                    "Your Benchmark",
                    benchmarkData.mapData.length,
                    benchmarkData.visitsCount,
                )}
            </ChartBodyWrapper>
        </ReportDataWrapper>
    );
};
